

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

    1: { // Exercise num
        unit: 'Review 3',
        id: 'SB5-V2-PV3-P71-E1',
        audio: '',
        video: '',
        padding: 0,
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page71/E1/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page71/E1/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page71/E1/2.jpg' },
                { url: 'img/FriendsPlus/Page71/E1/3.jpg', input: true, answer: "an" },
                { url: 'img/FriendsPlus/Page71/E1/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page71/E1/5.jpg' },
                { url: 'img/FriendsPlus/Page71/E1/6.jpg', input: true, answer: "some" },
                { url: 'img/FriendsPlus/Page71/E1/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page71/E1/8.jpg' },
                { url: 'img/FriendsPlus/Page71/E1/9.jpg', input: true, answer: "a" },
                { url: 'img/FriendsPlus/Page71/E1/10.jpg' },
                { url: 'img/FriendsPlus/Page71/E1/11.jpg', input: true, answer: "some" },
                { url: 'img/FriendsPlus/Page71/E1/12.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page71/E1/13.jpg' },
                { url: 'img/FriendsPlus/Page71/E1/14.jpg', input: true, answer: "a" },
                { url: 'img/FriendsPlus/Page71/E1/15.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page71/E1/16.jpg' },
            ]
        ],
    },

    2: { // Exercise num
        unit: 'Review 3',
        id: 'SB5-V2-PV3-P71-E2',
        audio: '',
        video: '',
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page71/E2/Key/answerKey.png',
        questionImage: [ // Row      
            [
                // Column1
                { url: 'img/FriendsPlus/Page71/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page71/E2/2.jpg' },
                { url: 'img/FriendsPlus/Page71/E2/3.jpg', input: true, answer: "smallest" },
                { url: 'img/FriendsPlus/Page71/E2/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page71/E2/5.jpg' },
                { url: 'img/FriendsPlus/Page71/E2/6.jpg', input: true, answer: "biggest" },
                { url: 'img/FriendsPlus/Page71/E2/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page71/E2/8.jpg' },
                { url: 'img/FriendsPlus/Page71/E2/9.jpg', input: true, answer: "faster" },
                { url: 'img/FriendsPlus/Page71/E2/10.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page71/E2/11.jpg' },
                { url: 'img/FriendsPlus/Page71/E2/12.jpg', input: true, answer: "fastest" },
                { url: 'img/FriendsPlus/Page71/E2/13.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page71/E2/14.jpg' },
            ],


        ],
    },
    3: { // Exercise num
        unit: 'Review 3',
        id: 'SB5-V2-PV3-P71-E3',
        audio: '',
        video: '',
        component: D1,
        padding: '0 0 0 5px',
        exerciseKey: 'img/FriendsPlus/Page71/E3/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page71/E3/1.jpg' },
            ],
            [
                // Column2  
                { url: 'img/FriendsPlus/Page71/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page71/E3/3.jpg', input: true, answer: "mp" },
                { url: 'img/FriendsPlus/Page71/E3/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page71/E3/5.jpg' },
                { url: 'img/FriendsPlus/Page71/E3/6.jpg', input: true, answer: "nt" },
                { url: 'img/FriendsPlus/Page71/E3/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page71/E3/8.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page71/E3/9.jpg' },
                { url: 'img/FriendsPlus/Page71/E3/10.jpg', input: true, answer: "lt" },
                { url: 'img/FriendsPlus/Page71/E3/11.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page71/E3/12.jpg' },
                { url: 'img/FriendsPlus/Page71/E3/13.jpg', input: true, answer: "nd" },
                { url: 'img/FriendsPlus/Page71/E3/14.jpg' },
                { url: 'img/FriendsPlus/Page71/E3/15.jpg', input: true, answer: "ld" },
                { url: 'img/FriendsPlus/Page71/E3/16.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page71/E3/17.jpg' },
            ],


        ],
    },



}
export default json;
